import { capitalize } from 'vue';

import ChartActionId from '@/common/enums/chart-action-id.enum';
import ChartGroupActionType from '@/common/enums/chart-group-action-type.enum';
import ChartAction from '@/common/models/chart/ChartAction';
import ChartGroupAction from '@/common/models/chart/ChartGroupAction';
import i18n from '@/vueI18n';

export default class ChartFullscreenActions {
  static getActions(rank: number, isHighlighted: boolean): ChartGroupAction {
    return new ChartGroupAction(
      ChartActionId.FULLSCREEN,
      ChartGroupActionType.CLICKABLE,
      capitalize(i18n.global.t('messages.fullscreen')),
      rank,
      [
        new ChartAction(
          i18n.global.t('messages.fullscreen'),
          false,
          capitalize(i18n.global.t('messages.fullscreen')),
          0,
        ),
      ],
      isHighlighted,
      false,
    );
  }
}
